<script>
  import { onMount } from 'svelte'
  export let stream
  export let full = false
  export let postfix = 1
  let player;

  export const play = () => {
    player.play();
  }

  export const setMute = (value) => {
    player.setMute(value);
  }

  export const getMute = () => {
    return player.getMute();
  }

  // Initialize OvenPlayer
  onMount(() => {
    player = OvenPlayer.create(`player_${stream}_${postfix}`, {
      autoStart: true,
      autoFallback: true,
      mute: !full,
      controls: false,
      sources: [{
        label: 'WebRTC',
        type: 'webrtc',
        file: `wss://dotterian.ru:3334/stopgame-live/${stream}`
      }, {
        label: 'HLS',
        type: "ll-hls",
        file: `https://dotterian.ru:3334/stopgame-live/${stream}/llhls.m3u8`
      }]
    })
  })
</script>

<div
  class:player-wrapper={!full}
  class:player-full={full}
>
  <div id="player_{stream}_{postfix}"></div>
</div>

<style>
  .player-wrapper {
    position: relative;
    max-height: 100%;
    aspect-ratio: 16/9;
    border-radius: 8px;
    overflow: hidden;
  }

  .player-full {
    position: relative;
    width: 100vw;
    height: 100vh;
  }
</style>
